import { FaqCategoryItem } from "../../types";

import { REQUIRED_LESSON_SETTINGS_FAQ } from "./RequiredLessonSettingsFaq";
import { STUDENT_MATERIAL_NOT_DISPLAYED_FAQ } from "./StudentMaterialNotDisplayedFaq";
import { MATERIAL_VIDEO_UNAVAILABLE_FAQ } from "./MaterialVideoUnavailableFaq";
import { STUDENT_GROUP_WORK_FAQ } from "./StudentGroupWorkFaq";
import { IPAD_APPLE_PENCIL_UNSTABLE_FAQ } from "./IpadApplePencilUnstableFaq";

export const LESSON_ITEMS: FaqCategoryItem[] = [
  REQUIRED_LESSON_SETTINGS_FAQ,
  STUDENT_MATERIAL_NOT_DISPLAYED_FAQ,
  MATERIAL_VIDEO_UNAVAILABLE_FAQ,
  STUDENT_GROUP_WORK_FAQ,
  IPAD_APPLE_PENCIL_UNSTABLE_FAQ,
];
